<template>
  <div ref="parent" style="margin: 10px auto;width: 70%;">
   <el-card v-if="!isNavCollapsed" >
      <el-button style="margin-bottom: 10px;float: right" type="info" @click="$router.go(-1)">返回</el-button>
      <div  style="display: flex">
        <div style="width: 70%">
          <img :src=item.img alt="" style="width: 100%; height: auto">
        </div>
        <div style="flex: 1; margin-left: 10px">
          <el-form label-width="80px" style="font-size: 20px">
            <el-form-item label="名称">{{ item.name }}</el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
    <el-card v-else >
      <el-button style="margin-bottom: 10px;float: right" type="info" @click="$router.go(-1)">返回</el-button>
      <div  >
        <h2 style="font-size: 15px;padding-top: 5px;" label="名称">{{ item.name }}</h2>
        <div style="width: 100%;">
          <img :src=item.img alt="" style="width: 100%; height: auto">
        </div>

      </div>
    </el-card>


    <el-card  v-if="!isNavCollapsed" style="margin-top: 20px">

      <h2>详情展示</h2>
     <mavon-editor style="width: 100%"
          class="md"
          :subfield="false"
          :value="item.content"
          :defaultOpen="'preview'"
          :toolbarsFlag="false"
          :editable="false"
          :scrollStyle="true"
          :ishljs="true"
      />;
    </el-card>

    <el-card v-else style="margin-top: 20px">

      <h2>详情展示</h2>
      <p class="p1">{{item.content}}</p>

    </el-card>

  </div>
</template>

<script>
export default {
  name: 'Detail',
  data() {
    return {
      isNavCollapsed: false, // 控制导航栏是否折叠
      isNavExpanded: false, // 控制下拉菜单是否展开
      parentWidth: window.innerWidth, // 初始宽度，将在mounted中更新
      user: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {},
      id: this.$route.query.id,
      item: {},
    }
  },
  created() {
    this.load()
  },
  mounted() {
    // 页面加载时从localStorage中读取状态
    window.addEventListener('resize', this.updateParentWidth);
    this.updateParentWidth();
  },
  methods: {
    updateParentWidth() {
      this.parentWidth = this.$refs.parent.offsetWidth;
      this.checkNavCollapse();
    },
    checkNavCollapse() {
      this.isNavCollapsed = this.parentWidth < 500;
    },
    load() {
      this.request.get('/clothing/' + this.id).then(res => {
        this.item = res.data
      })
    },
  }
}
</script>

<style>

</style>